var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14316 10C7.84964 10 8.54025 9.79051 9.12766 9.398C9.71506 9.00549 10.1729 8.4476 10.4432 7.79489C10.7135 7.14218 10.7842 6.42396 10.6464 5.73107C10.5085 5.03818 10.1682 4.40173 9.66864 3.90222C9.16904 3.40271 8.53254 3.06257 7.83962 2.92482C7.1467 2.78707 6.4285 2.85789 5.77583 3.12834C5.12317 3.39878 4.56536 3.85669 4.17295 4.44417C3.78055 5.03164 3.57117 5.72229 3.57129 6.42876C3.57228 7.37572 3.94894 8.2836 4.6186 8.95314C5.28826 9.62268 6.19621 9.99919 7.14316 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8156 12.9506C10.9105 12.0222 9.7492 11.3847 8.48003 11.1195C7.21086 10.8544 5.89145 10.9735 4.69033 11.4618C3.48921 11.9501 2.46091 12.7854 1.73679 13.8609C1.01266 14.9364 0.625586 16.2034 0.625 17.5C0.625 17.6658 0.690848 17.8247 0.808058 17.9419C0.925268 18.0591 1.08424 18.125 1.25 18.125H13.0375C13.2033 18.125 13.3622 18.0591 13.4794 17.9419C13.5967 17.8247 13.6625 17.6658 13.6625 17.5C13.6649 16.8373 13.5626 16.1783 13.3594 15.5475C13.0568 14.5723 12.5278 13.6824 11.8156 12.9506Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 10.3125C16.1545 10.3125 17.3438 9.12326 17.3438 7.65625C17.3438 6.18924 16.1545 5 14.6875 5C13.2205 5 12.0312 6.18924 12.0312 7.65625C12.0312 9.12326 13.2205 10.3125 14.6875 10.3125Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6876 11.0438C13.8498 11.0469 13.0283 11.2751 12.3088 11.7044C12.4445 11.8256 12.5813 11.945 12.7095 12.0763C13.5605 12.951 14.1927 14.0145 14.5545 15.18C14.6784 15.5637 14.7697 15.9572 14.8276 16.3563H18.7501C18.9158 16.3563 19.0748 16.2904 19.192 16.1732C19.3092 16.056 19.3751 15.897 19.3751 15.7313C19.3738 14.4885 18.8795 13.297 18.0007 12.4182C17.1219 11.5394 15.9304 11.0451 14.6876 11.0438Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.ad4c1ac9bdc1e61e9e511461a043c14d.svg";
export { ForwardRef as ReactComponent };